export default function rowMaker (orderedPhotos) {
    let values = {
        big:2,
        small:1,
        horizontal:3,
        wide:4,
    };
    let currentValue = 0;
    let perRow = 0;
    let results = [];
    let temp = [];
    for(let photo of orderedPhotos){
        let photoValue = values[photo.category];
        if(currentValue >= 4 || perRow === 2){
            results.push(temp);
            currentValue = 0;
            perRow = 0;
            temp = [];
        }
        temp.push(photo);
        currentValue += photoValue;
        perRow++
    }
    results.push(temp);
    return results;
}